import { render, staticRenderFns } from "./ButtonColors.vue?vue&type=template&id=27e45ddd"
import script from "./ButtonColors.vue?vue&type=script&lang=js"
export * from "./ButtonColors.vue?vue&type=script&lang=js"
import style0 from "./ButtonColors.vue?vue&type=style&index=0&id=27e45ddd&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QField from 'quasar/src/components/field/QField.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect,QAvatar,QItem,QField,QChip});
